import React,{useEffect,useState} from 'react';
import 'components/styles/layout.css';
import NotFound from 'pages/not-found';
import Layout from 'components/layout';
import { useSearchParams } from 'react-router-dom';
import { PARTNERSHIP_URL } from 'constants/index';
import axios from 'axios';
import useLoader  from 'hooks/useLoader';

// eslint-disable-next-line require-await
const getPartnerById = async (partnerId) => {
  let config = {
	  method: 'get',
	  maxBodyLength: Infinity,
	  url: `${PARTNERSHIP_URL}/partners/${partnerId}`,
	  headers: { 
		  'accept': 'application/json'
	  }
  };

  const response = await axios.request(config);
  return response?.data?.data;
};

const ProtectedLayout = () => {
  const { showLoader, hideLoader } = useLoader();
  const [searchParams] = useSearchParams();
  const partnerId = searchParams.get('partnerId');
  const [partner, setPartner] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPartner = async () => {
      if (!partnerId) {                          
        setIsLoading(false);
        return;
      }

      showLoader(); 
      try {
        const partnerResponse = await getPartnerById(partnerId);
        setPartner(partnerResponse);
      } catch (error) {
        setPartner(null);                         
      } finally {
        hideLoader();
        setIsLoading(false);                         
      }
    };
    fetchPartner();
  }, [partnerId, showLoader, hideLoader]);

  if (isLoading) {
    return null;
  }
  if (!partnerId || partner === null) {
    return <NotFound />; 
  }
  return <Layout partner={partner} />; 
};

export default ProtectedLayout;
